import{isC as t}from"../../patterns/react/C/C.js";import{isCC as r}from"../../patterns/react/CC/CC.js";var o=function(o){return t(o)||r(o)||"function"==typeof o};export{o as isAs};
//# sourceMappingURL=As.js.map
